import Utils from './Utils';
import ComboBox from './ComboBox';

class Pagination {
    constructor(domElement, key) {
        this.domElement = domElement;
        this.key = key;

        this.pageStartDomElement = this.domElement.getElementsByClassName('pagination-control-start')[0];
        this.pagePreviousDomElement = this.domElement.getElementsByClassName('pagination-control-previous')[0];
        this.pageNextDomElement = this.domElement.getElementsByClassName('pagination-control-next')[0];
        this.pageEndDomElement = this.domElement.getElementsByClassName('pagination-control-end')[0];
        this.pageDetailsDomElement = this.domElement.getElementsByClassName('pagination-control-page-details')[0];
        this.rowsPerPageDomElement = this.domElement.getElementsByClassName('pagination-control-rows-per-page-select')[0];

        this.currentPage = 0;
        this.rowsPerPage = 10;
        this.pageRowCount = 0;
        this.totalRowCount = 0;

        this.bindEvents();
        this.updatePagination();
        this.setRowsPerPage(localStorage.getItem(`brvis-pagination-${this.key}`) || 10);
    }

    bindEvents() {
        if (!!this.pageStartDomElement) {
            this.pageStartDomElement.addEventListener('click', this.onPageStartClick.bind(this));
        }

        if (!!this.pagePreviousDomElement) {
            this.pagePreviousDomElement.addEventListener('click', this.onPagePreviousClick.bind(this));
        }

        if (!!this.pageNextDomElement) {
            this.pageNextDomElement.addEventListener('click', this.onPageNextClick.bind(this));
        }

        if (!!this.pageEndDomElement) {
            this.pageEndDomElement.addEventListener('click', this.onPageEndClick.bind(this));
        }

        if (!!this.rowsPerPageDomElement) {
            this.rowsPerPageComboBox = ComboBox.fromSelectElement(this.rowsPerPageDomElement);
            this.rowsPerPageComboBox.addEventListener('value_change', this.onRowsPerPageChange.bind(this));
        }
    }

    onPageStartClick(e) {
        e.preventDefault();

        const hashBang = Utils.getHashbangValue(window.location.hash);
        const queryObj = Utils.queryToObject(hashBang);

        queryObj['limit'] = this.rowsPerPage;
        queryObj['skip'] = 0;

        window.location.hash = '!/' + Utils.objectToQuery(queryObj);
    }

    onPagePreviousClick(e) {
        e.preventDefault();

        const hashBang = Utils.getHashbangValue(window.location.hash);
        const queryObj = Utils.queryToObject(hashBang);

        queryObj['limit'] = this.rowsPerPage;
        queryObj['skip'] = parseInt(queryObj['skip'] || '0') - this.rowsPerPage;

        if (queryObj['skip'] < 0) {
            queryObj['skip'] = 0;
        }

        window.location.hash = '!/' + Utils.objectToQuery(queryObj);
    }

    onPageNextClick(e) {
        e.preventDefault();

        const hashBang = Utils.getHashbangValue(window.location.hash);
        const queryObj = Utils.queryToObject(hashBang);

        queryObj['limit'] = this.rowsPerPage;
        queryObj['skip'] = parseInt(queryObj['skip'] || '0') + this.rowsPerPage;

        window.location.hash = '!/' + Utils.objectToQuery(queryObj);
    }

    onPageEndClick(e) {
        e.preventDefault();

        const hashBang = Utils.getHashbangValue(window.location.hash);
        const queryObj = Utils.queryToObject(hashBang);

        queryObj['limit'] = this.rowsPerPage;
        queryObj['skip'] = ((Math.ceil(this.totalRowCount / this.rowsPerPage) - 1) *
            this.rowsPerPage);

        window.location.hash = '!/' + Utils.objectToQuery(queryObj);
    }

    onRowsPerPageChange(e) {
        const rowsPerPage = e.value;

        this.setRowsPerPage(rowsPerPage);
        localStorage.setItem(`brvis-pagination-${this.key}`, rowsPerPage);
    }

    setCurrentPage(page) {
        this.currentPage = typeof (page) === 'string' ? parseInt(page) : page;
        this.updatePagination();
    }

    setRowsPerPage(rowsPerPage) {
        this.rowsPerPage = typeof (rowsPerPage) === 'string' ? parseInt(rowsPerPage) : rowsPerPage;
        this.rowsPerPageComboBox.setValue(rowsPerPage, false);

        const hashBang = Utils.getHashbangValue(window.location.hash);
        const queryObj = Utils.queryToObject(hashBang);

        queryObj['limit'] = this.rowsPerPage;
        window.location.hash = '!/' + Utils.objectToQuery(queryObj);

        this.updatePagination();
    }

    setPageRowCount(pageRowCount) {
        this.pageRowCount = pageRowCount;
        this.updatePagination();
    }

    setTotalRowCount(totalRowCount) {
        this.totalRowCount = typeof (totalRowCount) === 'string' ? parseInt(totalRowCount) : totalRowCount;
        this.updatePagination();
    }

    updatePagination() {
        const rangeStart = this.currentPage * this.rowsPerPage;
        const rangeEnd = rangeStart + this.pageRowCount;
        this.pageDetailsDomElement.innerHTML = rangeStart + '-' + rangeEnd + ' of ' + this.totalRowCount;

        if (rangeStart > 0) {
            this.pageStartDomElement.classList.remove('disabled');
            this.pagePreviousDomElement.classList.remove('disabled');
        } else {
            this.pageStartDomElement.classList.add('disabled');
            this.pagePreviousDomElement.classList.add('disabled');
        }

        if (rangeEnd < this.totalRowCount) {
            this.pageNextDomElement.classList.remove('disabled');
            this.pageEndDomElement.classList.remove('disabled');
        } else {
            this.pageNextDomElement.classList.add('disabled');
            this.pageEndDomElement.classList.add('disabled');
        }
    }
}

export default Pagination;
